<template>
  <div class="client-opration">
    <div class="add-wrap">
      <div class="form-wrap">
        <div class="title">基本信息</div>
        <!-- 企业信息模板 -->
        <div
          class="info form-info"
          v-if="
            clientAuditDetail.commonCustomer &&
            clientAuditDetail.commonCustomer.categoryUid !==
              'ed67aad9552b4f1b8520785b9cb4bfd1'
          "
        >
          <el-row>
            <el-col :span="4">
              <div class="info-title">客户类型：</div>
            </el-col>
            <el-col :span="20">
              <div
                class="info-detail"
                v-text="
                  clientAuditDetail.commonCustomer &&
                  clientAuditDetail.commonCustomer.categoryName
                "
              ></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">客户名称：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{
                  clientAuditDetail.commonCustomer &&
                  clientAuditDetail.commonCustomer.name
                }}
                {{
                  clientAuditDetail.commonCustomer &&
                  clientAuditDetail.commonCustomer.depaName
                }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">统一社会信用代码：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail" v-text="clientAuditDetail.creditCode"></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">注册资金（万元）：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    clientAuditDetail.commonCustomer &&
                    clientAuditDetail.commonCustomer.capital
                  }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">规模（人）：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    clientAuditDetail.commonCustomer &&
                    clientAuditDetail.commonCustomer.scale
                  }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">地区：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    clientAuditDetail.commonCustomer &&
                    clientAuditDetail.commonCustomer.province
                  }}
                  {{
                    clientAuditDetail.commonCustomer &&
                    clientAuditDetail.commonCustomer.city
                  }}
                  {{
                    clientAuditDetail.commonCustomer &&
                    clientAuditDetail.commonCustomer.district
                  }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">详细地址：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail" v-text="clientAuditDetail.streetAddress"></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">业务员：</div>
            </el-col>
            <el-col :span="20">
              <div
                class="info-detail"
                v-text="
                  clientAuditDetail.commonCustomer &&
                  clientAuditDetail.commonCustomer.salesmanName
                "
              ></div>
            </el-col>
          </el-row>
        </div>
        <!-- 医院信息模板 -->
        <div
          class="info form-info"
          v-if="
            clientAuditDetail.commonCustomer &&
            clientAuditDetail.commonCustomer.categoryUid ===
              'ed67aad9552b4f1b8520785b9cb4bfd1'
          "
        >
          <el-row>
            <el-col :span="4">
              <div class="info-title">客户类型：</div>
            </el-col>
            <el-col :span="20">
              <div
                class="info-detail"
                v-text="
                  clientAuditDetail.commonCustomer &&
                  clientAuditDetail.commonCustomer.categoryName
                "
              ></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">客户名称：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    clientAuditDetail.commonCustomer &&
                    clientAuditDetail.commonCustomer.name
                  }}
                  {{
                    clientAuditDetail.commonCustomer &&
                    clientAuditDetail.commonCustomer.depaName
                  }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">跟进状态：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.followUpStateName }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">医院等级：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.hospitalLevelName }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">病床数：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.sickbedNumber }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">覆盖人口(万)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.coverPopulation }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">当地医院排名：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.hospitalRhanking }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">年收入(万元)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.annualIncome }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">职工人数：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.employeeNumber }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">年门诊人次(万)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.outpatientVisits }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">合作科室：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{
                    clientAuditDetail.customerDetail
                      .map((item) => item.dictName)
                      .join("、")
                  }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">年住院人次(万)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.hospitalizationVisits }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">负债率：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">{{ clientAuditDetail.liabilities }}%</div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">医疗设备：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.medicalEquipment === 1 ? "有" : "无" }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12" v-if="clientAuditDetail.medicalEquipment === 1">
              <el-col :span="8">
                <div class="info-title">设备总金额(万元)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.deviceAmount }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row v-if="clientAuditDetail.medicalEquipment === 1">
            <el-col :span="4">
              <div class="info-title">设备名称：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{ clientAuditDetail.deviceName }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-col :span="8">
                <div class="info-title">耗材：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.consumables === 1 ? "有" : "无" }}
                </div>
              </el-col>
            </el-col>
            <el-col :span="12" v-if="clientAuditDetail.consumables === 1">
              <el-col :span="8">
                <div class="info-title">耗材流水(万元/年)：</div>
              </el-col>
              <el-col :span="16">
                <div class="info-detail">
                  {{ clientAuditDetail.consumablesRunningWater }}
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">备注：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{ clientAuditDetail.customerRemarks }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">地区：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{
                  clientAuditDetail.commonCustomer &&
                  clientAuditDetail.commonCustomer.province
                }}
                {{
                  clientAuditDetail.commonCustomer &&
                  clientAuditDetail.commonCustomer.city
                }}
                {{
                  clientAuditDetail.commonCustomer &&
                  clientAuditDetail.commonCustomer.district
                }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">详细地址：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail" v-text="clientAuditDetail.streetAddress"></div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="info-title">业务员：</div>
            </el-col>
            <el-col :span="20">
              <div class="info-detail">
                {{
                  clientAuditDetail.commonCustomer &&
                  clientAuditDetail.commonCustomer.salesmanName
                }}
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 联系人列表 -->
        <div class="title">联系人</div>
        <div class="form-info" v-loading="isContactsLoading">
          <el-table :data="auditContacts.results" border style="width: 100%">
            <el-table-column prop="name" align="center" label="姓名"> </el-table-column>
            <el-table-column prop="mobile" align="center" label="联系方式">
            </el-table-column>
            <el-table-column prop="typeName" align="center" label="类型">
            </el-table-column>
            <el-table-column prop="duty" align="center" label="职务"> </el-table-column>
            <el-table-column prop="contactDepa" align="center" label="部门">
            </el-table-column>
            <el-table-column prop="contactEmail" align="center" label="邮箱">
            </el-table-column>
          </el-table>
          <el-pagination
            class="linkman-pagination"
            @current-change="handleCurrentChange"
            :current-page.sync="contacts.pageNumber"
            :page-size.sync="contacts.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="auditContacts.totalCount"
          >
          </el-pagination>
        </div>
        <!-- 审核备注 -->
        <div class="title">审核备注</div>
        <div class="form-info">
          <el-input
            class="audit-remark"
            v-if="isAudit"
            type="textarea"
            :rows="4"
            v-model="remark"
            placeholder="请输入审核备注（非必填）"
          ></el-input>
          <span v-else>{{ remark }}</span>
        </div>

        <!-- 操作 -->
        <div class="btn-group">
          <el-button @click="goBack()"> 返回 </el-button>
          <el-button
            v-if="
              isAudit &&
              auth.customerApproveUnPass &&
              auth.customerApproveUnPass.toggleStatus
            "
            type="danger"
            @click="refuse()"
          >
            驳回
          </el-button>
          <el-button
            v-if="
              isAudit && auth.CustomerApprovePass && auth.CustomerApprovePass.toggleStatus
            "
            type="success"
            @click="pass()"
          >
            通过
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CustomInfo from "~component/business/custom/customInfo.vue";

export default {
  components: {
    CustomInfo,
  },
  data() {
    return {
      auditionModule: null,
      remark: "",
      contacts: {
        pageNumber: 1,
        pageSize: 10,
      },
      isContactsLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
      clientAuditDetail: "audit/clientAuditDetail",
      auditContacts: "audit/auditContacts",
    }),
    isAudit() {
      return this.$route.query.isAudit;
    },
  },
  created() {
    this.getDetailData();
    this.getCustomContacts();
  },
  methods: {
    ...mapActions({
      getClientAuditDetail: "audit/getClientAuditDetail",
      passClientAudit: "audit/passClientAudit",
      refuseClientAudit: "audit/refuseClientAudit",
      getAuditContactsList: "audit/getAuditContactsList",
    }),
    getDetailData() {
      this.getClientAuditDetail({
        uid: this.$route.query.uid,
        type: this.$route.query.type,
      }).then(() => {
        this.remark = this.clientAuditDetail.commonCustomer.remark;
      });
    },
    getCustomContacts() {
      this.isContactsLoading = true;
      this.getAuditContactsList({
        customerUid: this.$route.query.uid,
        pageNumber: this.contacts.pageNumber,
        pageSize: this.contacts.pageSize,
        sourcePart: "customer",
      }).finally(() => {
        this.isContactsLoading = false;
      });
    },
    handleCurrentChange() {
      this.getCustomContacts();
    },
    pass() {
      this.passClientAudit({
        uid: this.$route.query.uid,
        remark: this.remark,
      }).then(() => {
        this.$message({
          message: "审核通过",
          type: "success",
        });
        this.goBack();
      });
    },
    refuse() {
      this.refuseClientAudit({
        uid: this.$route.query.uid,
        remark: this.remark,
      }).then(() => {
        this.$message({
          message: "审核驳回",
          type: "success",
        });
        this.goBack();
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less">
@import "~@/styles/var.less";

.client-opration {
  .add-wrap {
    width: @maxWidth;
    margin: 0 auto;
    background: #fff;
    margin-top: 30px;
  }
  .info-title {
    height: 40px;
    line-height: 40px;
    color: #2c3e50;
    font-weight: 500;
    text-align: right;
    padding: 8px 0;
  }
  .info-detail {
    height: 40px;
    line-height: 40px;
    padding: 8px 0;
    font-size: 14px;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .form-info {
    margin: 16px 32px;
    width: calc(~"100% - 64px");
    .linkman-pagination {
      text-align: right;
      margin-bottom: 16px;
    }
  }
  .audit-remark {
    font-size: 14px;
  }
  .btn-group {
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
}
</style>
